import { dateToInt, intToDate } from '@saliente/library';
import { Type, Exclude, Expose, instanceToInstance } from 'class-transformer';
import { SuspendareModel, SysCasaSanatate, SysDictionaryStandardFields, SysModelContract, SysDictionaryRegesFields, SysTipNorma } from '../common/payroll.models';
import { round } from 'lodash-es';

export enum EmployeeStatus {
	Draft = 'Draft',
	Active = 'Activ',
	Suspended = 'Suspendat',
	Pending = 'In curs'
}

export enum CertificateType {
    SAL = 'SAL',
    CM = 'CM',
	CIC = 'CIC',
	STAG = 'STAG',
	SAL_MND = 'SAL_MND',
	CM_MND = 'CM_MND',
	CIC_MND = 'CIC_MND',
	STAG_MND = 'STAG_MND'
}

export enum GeneratedDocumentType {
	CONTRACT = 'CONTRACT',
	MODIFICARE_SALARIU = 'MODIFICARE_SALARIU',
	DEMISIE_ACORD_PARTI = 'DEMISIE_ACORD_PARTI',
	DECIZIE_INCETARE_CDA = 'DECIZIE_INCETARE_CDA',
	DECIZIE_INCETARE_MND = 'DECIZIE_INCETARE_MND',
	SAL = 'SAL',
	CM = 'CM',
	CIC = 'CIC',
	STAG = 'STAG',
	SAL_MND = 'SAL_MND',
	CM_MND = 'CM_MND',
	CIC_MND = 'CIC_MND',
	STAG_MND = 'STAG_MND'
}

export class EmployeeDocumentAvailability {
	public documentType: string;
	public available: boolean;
	public message: string;
}

export class SysStatusAngajat {
	public id: number;
	public code: string;
	public display: string;
	public categorie?: string;

	static typeProvider() {
		return SysStatusAngajat;
	}
}

export class SysTipAngajat {
	public id: number;
	public code: string;
	public display: string;
	public cas: boolean;
	public cass: boolean;
	public impozit: boolean;
	public cam: boolean;
	public deducere: boolean;

	static typeProvider() {
		return SysTipAngajat;
	}
}

export class SysFunctieCor {
	public id: number;
	public code: string;
	public display: string;

	public get fullDisplay(): string {
        return `(${this.code}) ${this.display}`;
    }
}

export class CountyModel {
	public id: number;
	public code: string;
	public display: string;

	static typeProvider() {
		return CountyModel;
	}
}

export class CityModel {
	public id: number;
	public codSiruta: string;
	public display: string;
	public county: CountyModel;

	static typeProvider() {
		return CityModel;
	}
}

export class CoasiguratModel {
	public externalId: string;
	public clientEid: string;
	public tipCoasiguratId: number;
	public numeCoasigurat: string;
	public prenumeCoasigurat: string;
	public cnp: string;
	public deLa: number;
	@Exclude()
	private _deLaEx: Date;
	@Exclude()
	public get deLaEx(): Date {
		if (!this._deLaEx && this.deLa) {
			this._deLaEx = intToDate(this.deLa);
		}
		return this._deLaEx;
	}
	public set deLaEx(value: Date) {
		if (this._deLaEx != value) {
			this._deLaEx = value;
			this.deLa = dateToInt(value);
		}
	}
	public panaLa: number;
	@Exclude()
	private _panaLaEx: Date;
	@Exclude()
	public get panaLaEx(): Date {
		if (!this._panaLaEx && this.panaLa) {
			this._panaLaEx = intToDate(this.panaLa);
		}
		return this._panaLaEx;
	}
	public set panaLaEx(value: Date) {
		if (this._panaLaEx != value) {
			this._panaLaEx = value;
			this.panaLa = dateToInt(value);
		}
	}
	@Exclude()
	public isNew: boolean; // new or update existing
	@Exclude()
	public isAdded: boolean = true; //need it when main save button (for new contract) is pressed multiple times;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public tipCoasigurat: SysDictionaryStandardFields;

	static typeProvider() {
		return CoasiguratModel;
	}

	public clone(): CoasiguratModel {
		return instanceToInstance(this, { ignoreDecorators: true });
	}
}

export class DeducereModel {
	public externalId: string;
	public clientEid: string;
	public persoanaInDeducere: string;
	public cnpPersoana: string;
	public tipDeducereId: string;
	public gradHandicapId: number;
	public deLa: number;
	@Exclude()
	private _deLaEx: Date;
	@Exclude()
	public get deLaEx(): Date {
		if (!this._deLaEx && this.deLa) {
			this._deLaEx = intToDate(this.deLa);
		}
		return this._deLaEx;
	}
	public set deLaEx(value: Date) {
		if (this._deLaEx != value) {
			this._deLaEx = value;
			this.deLa = dateToInt(value);
		}
	}
	public panaLa: number;
	@Exclude()
	private _panaLaEx: Date;
	@Exclude()
	public get panaLaEx(): Date {
		if (!this._panaLaEx && this.panaLa) {
			this._panaLaEx = intToDate(this.panaLa);
		}
		return this._panaLaEx;
	}
	public set panaLaEx(value: Date) {
		if (this._panaLaEx != value) {
			this._panaLaEx = value;
			this.panaLa = dateToInt(value);
		}
	}
	@Exclude()
	public isNew: boolean; // new or update existing
	@Exclude()
	public isAdded: boolean = true; //need it when main save button (for new contract) is pressed multiple times;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public gradHandicap: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public tipDeducere: SysDictionaryStandardFields;

	static typeProvider() {
		return DeducereModel;
	}

	public clone(): DeducereModel {
		return instanceToInstance(this, { ignoreDecorators: true });
	}
}

export class HandicapModel {
	public externalId: string;
	public clientEid: string;
	//public employeeEid: string;
	public tipHandicapId: number;
	public gradHandicapId: number;
	public tipHandicapRegesId: number;
	public documentEid: string;
	public numarCertificatHandicap: string;
	public deLa: number;
	@Exclude()
	private _deLaEx: Date;
	@Exclude()
	public get deLaEx(): Date {
		if (!this._deLaEx && this.deLa) {
			this._deLaEx = intToDate(this.deLa);
		}
		return this._deLaEx;
	}
	public set deLaEx(value: Date) {
		if (this._deLaEx != value) {
			this._deLaEx = value;
			this.deLa = dateToInt(value);
		}
	}
	public panaLa: number;
	@Exclude()
	private _panaLaEx: Date;
	@Exclude()
	public get panaLaEx(): Date {
		if (!this._panaLaEx && this.panaLa) {
			this._panaLaEx = intToDate(this.panaLa);
		}
		return this._panaLaEx;
	}
	public set panaLaEx(value: Date) {
		if (this._panaLaEx != value) {
			this._panaLaEx = value;
			this.panaLa = dateToInt(value);
		}
	}
	public activ: boolean;

	@Exclude()
	public isNew: boolean; // new or update existing
	@Exclude()
	public isAdded: boolean = true; //need it when main save button (for new contract) is pressed multiple times;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public tipHandicap: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public gradHandicap: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public tipHandicapReges: SysDictionaryStandardFields;
	
	static typeProvider() {
		return HandicapModel;
	}

	public clone(): HandicapModel {
		return instanceToInstance(this, { ignoreDecorators: true });
	}
}

export class AngajatAttachmentModel {
	public fileType: string;
	public fileEid: string;
	public fileName: string;
	public fileSize: number;
	public displayOrder: number;

	@Exclude()
	public get convertedFileSize(): number {
		// 1 KB = 1024 bytes; 1 MB = 1024 KB; 1 GB = 1024 MB
		// 1mb = 1 * 1024 * 1024
		if (this.fileSize >= 1048576) { // 1024 * 1024
			return round(this.fileSize / 1048576, 2); // = MB
		}
		else if (this.fileSize >= 1024 && this.fileSize < 1048576) {
			return round(this.fileSize / 1024, 2)// = KB
		}
		else if (this.fileSize < 1024) {
			return round(this.fileSize, 2); // = B
		}
		else {
			return round(this.fileSize, 2)
		}
	}

	@Exclude()
	public get convertedFileUM(): string {
		// 1 KB = 1024 bytes; 1 MB = 1024 KB; 1 GB = 1024 MB
		// 1mb = 1 * 1024 * 1024
		if (this.fileSize >= 1048576) { // 1024 * 1024
			return "MB";
		}
		else if (this.fileSize >= 1024 && this.fileSize < 1048576) {
			return "KB";
		}
		else if (this.fileSize < 1024) {
			return "B";
		}
		else {
			return "B";
		}
	}

	
	static typeProvider() {
		return AngajatAttachmentModel;
	}
}

export class EmployeeListModel {
	public recordsCount: number;
	public first: number;
	public last: number;
	public data: EmployeeModel[];
}

export class EmployeeModel {
	@Exclude()
	public displayIndex: number;
	public externalId: string;
	public cnp: string;
	public prenume: string;
	public nume: string;
	public contractNo: string;
	public contractDate: number;
	@Exclude()
	private _contractDateEx: Date;
	@Exclude()
	public get contractDateEx(): Date {
		if (!this._contractDateEx && this.contractDate) {
			this._contractDateEx = intToDate(this.contractDate);
		}
		return this._contractDateEx;
	}
	public set contractDateEx(value: Date) {
		if (this._contractDateEx != value) {
			this._contractDateEx = value;
			this.contractDate = dateToInt(value);
		}
	}
	public siteName: string;
	public departament: string;
	public validat: boolean;

	@Exclude()
	private _fullName: string;
	@Exclude()
	public get fullName() {
		if (!this._fullName) {
			this._fullName = `${this.nume} ${this.prenume}`;
		}
		return this._fullName;
	}
	
	public tarifarIncadrare: number;
	public minimumWage: number;
	public hasMinimumWage: boolean;
	public minimumWageYearsExceeded: boolean;
	public minimumWageDate: number;
	public hasSuspensionOrder: boolean;
	public anafSuspended: boolean;
	@Exclude()
	private _minimumWageDateEx: Date;
	@Exclude()
	public get minimumWageDateEx(): Date {
		if (!this._minimumWageDateEx && this.minimumWageDate) {
			this._minimumWageDateEx = intToDate(this.minimumWageDate);
		}
		return this._minimumWageDateEx;
	}
	public set minimumWageDateEx(value: Date) {
		if (this._minimumWageDateEx != value) {
			this._minimumWageDateEx = value;
			this.minimumWageDate = dateToInt(value);
		}
	}

	public tipLocMunca: string;

	@Type(SysModelContract.typeProvider)
	public modelContract: SysModelContract;

	@Type(SysStatusAngajat.typeProvider)
	public statusAngajat: SysStatusAngajat;

	static typeProvider() {
		return EmployeeModel;
	}
}

export class EmployeeDetailsModel {
	@Exclude()
	public displayIndex: number;
	// @Exclude()
	// public prevEmployeeEid: string;
	// @Exclude()
	// public nextEmployeeEid: string;

	public initialaTata: string;
	public dataNasterii: number;
	@Exclude()
	private _dataNasteriiEx: Date;
	@Exclude()
	get dataNasteriiEx() {
		if (!this._dataNasteriiEx && this.dataNasterii) {
			this._dataNasteriiEx = intToDate(this.dataNasterii);
		}
		return this._dataNasteriiEx;
	}
	set dataNasteriiEx(value: Date) {
		if (this._dataNasteriiEx != value) {
			this._dataNasteriiEx = value;
			this.dataNasterii = dateToInt(value);
		}
	}
	public cis: string;
	public email: string;
	public telefon: string;
	public adresa: string;
	public judetId: number;
	public judetCod: string;
	public judetNume: string;
	public orasId: number;
	public orasNume: string;
	public taraCod: string = "RO";
	public taraNume: string = "România";
	public banca: string;
	public iban: string;
	public cetatenieCod: string;
	public cetatenieNume: string;
	public localitateNastere: string;
	@Exclude()
	public cetatenieRegiune: string;
	public serie: string;
	public numar: string;
	public eliberatDe: string;
	public valabilDeLa: number;
	@Exclude()
	private _valabilDeLaEx: Date;
	@Exclude()
	get valabilDeLaEx() {
		if (!this._valabilDeLaEx && this.valabilDeLa) {
			this._valabilDeLaEx = intToDate(this.valabilDeLa);
		}
		return this._valabilDeLaEx;
	}
	set valabilDeLaEx(value: Date) {
		if (this._valabilDeLaEx != value) {
			this._valabilDeLaEx = value;
			this.valabilDeLa = dateToInt(value);
		}
	}
	public valabilPanaLa: number;
	@Exclude()
	private _valabilPanaLaEx: Date;
	@Exclude()
	get valabilPanaLaEx() {
		if (!this._valabilPanaLaEx && this.valabilPanaLa) {
			this._valabilPanaLaEx = intToDate(this.valabilPanaLa);
		}
		return this._valabilPanaLaEx;
	}
	set valabilPanaLaEx(value: Date) {
		if (this._valabilPanaLaEx != value) {
			this._valabilPanaLaEx = value;
			this.valabilPanaLa = dateToInt(value);
		}
	}
	public hasCNP: boolean | null;
	public hasNIF: boolean | null;
	public hasPassport: boolean | null;
	public dataPlecarii: number;
	@Exclude()
	private _dataPlecariiEx: Date;
	@Exclude()
	public get dataPlecariiEx(): Date {
		if (!this._dataPlecariiEx && this.dataPlecarii) {
			this._dataPlecariiEx = intToDate(this.dataPlecarii);
		}
		return this._dataPlecariiEx;
	}
	public set dataPlecariiEx(value: Date) {
		if (this._dataPlecariiEx != value) {
			this._dataPlecariiEx = value;
			this.dataPlecarii = dateToInt(value);
		}
	}
	public contractNo: string;
	public contractDate: number;
	@Exclude()
	private _contractDateEx: Date;
	@Exclude()
	public get contractDateEx(): Date {
		if (!this._contractDateEx && this.contractDate) {
			this._contractDateEx = intToDate(this.contractDate);
		}
		return this._contractDateEx;
	}
	public set contractDateEx(value: Date) {
		if (this._contractDateEx != value) {
			this._contractDateEx = value;
			this.contractDate = dateToInt(value);
		}

		// let nextDay = new Date(value);
		// nextDay.setDate(value.getDate() + 1);
		// this._minDataAngajariiEx = nextDay;

	}
	public perioadaProba: number;
	public contractDocumentEid: string;
	public preavizDemisie: number;
	public preavizConcediere: number;
	public dataPlataAvans: number;
	@Exclude()
	private _dataPlataAvansEx: Date;
	@Exclude()
	public get dataPlataAvansEx(): Date {
		if (!this._dataPlataAvansEx && this.dataPlataAvans) {
			this._dataPlataAvansEx = intToDate(this.dataPlataAvans);
		}
		return this._dataPlataAvansEx;
	}
	public set dataPlataAvansEx(value: Date) {
		if (this._dataPlataAvansEx != value) {
			this._dataPlataAvansEx = value;
			this.dataPlataAvans = dateToInt(value);
		}
	}
	public dataPlataLichidare: number;
	@Exclude()
	private _dataPlataLichidareEx: Date;
	@Exclude()
	public get dataPlataLichidareEx(): Date {
		if (!this._dataPlataLichidareEx && this.dataPlataLichidare) {
			this._dataPlataLichidareEx = intToDate(this.dataPlataLichidare);
		}
		return this._dataPlataLichidareEx;
	}
	public set dataPlataLichidareEx(value: Date) {
		if (this._dataPlataLichidareEx != value) {
			this._dataPlataLichidareEx = value;
			this.dataPlataLichidare = dateToInt(value);
		}
	}
	public obiectContract: string;
	public scurtaCaracterizarePost: string;
	public criteriiEvaluare: string;
	public tipDocumentPersonalId: number;
	
	@Type(AngajatAttachmentModel.typeProvider)
	public angajatAttachments: AngajatAttachmentModel[] = [];

	public nume: string;
	public prenume: string;
	public cnp: string;
	public dataAngajarii: number;
	@Exclude()
	private _dataAngajariiEx: Date;
	@Exclude()
	public get dataAngajariiEx(): Date {
		if (!this._dataAngajariiEx && this.dataAngajarii) {
			this._dataAngajariiEx = intToDate(this.dataAngajarii);
		}
		return this._dataAngajariiEx;
	}
	public set dataAngajariiEx(value: Date) {
		if (this._dataAngajariiEx != value) {
			this._dataAngajariiEx = value;
			this.dataAngajarii = dateToInt(value);
		}
	}
	@Exclude()
	public get minDataAngajariiEx(): Date {
		if (this.contractDate && this.modelContract && this.modelContract.beneficiiTipSalariat) {
			let nextDay = new Date(this._contractDateEx);
			nextDay.setDate(this._contractDateEx.getDate() + 1);

			return nextDay;
		}
		else {
			return this._contractDateEx;
		}
	}
	public tarifarIncadrare: number;
	public functieInterna: string;
	public siteEid: string;
	public siteName: string;
	public numarOre: number;
	public dataTerminarii: number;
	@Exclude()
	private _dataTerminariiEx: Date;
	@Exclude()
	public get dataTerminariiEx(): Date {
		if (!this._dataTerminariiEx && this.dataTerminarii) {
			this._dataTerminariiEx = intToDate(this.dataTerminarii);
		}
		return this._dataTerminariiEx;
	}
	public set dataTerminariiEx(value: Date) {
		if (this._dataTerminariiEx != value) {
			this._dataTerminariiEx = value;
			this.dataTerminarii = dateToInt(value);
		}
	}
	public functieBaza: boolean;
	public sporWeekend: boolean;
	public departament: string;
	public concediuOdihna: number;
	public concediuOdihnaSuplimentar: number;
	public scutitImpozitIt: boolean;
	public pensionar: boolean;
	public sexId: number;
	public casaSanatateId: number;
	public tipNormaId: number;
	public repartizareTipMuncaId: number;
	public durataContractId: number;
	public functieCorId: number;
	public conditiiMuncaId: number;
	public statusAngajatId: number;
	public modelContractId: number;
	public tipAngajatId: number;
	public tipOreId: number;
	public tipSporWeekendId: number;
	public dataAsigurat: number;
	@Exclude()
	private _dataAsiguratEx: Date;
	@Exclude()
	public get dataAsiguratEx(): Date {
		if (!this._dataAsiguratEx && this.dataAsigurat) {
			this._dataAsiguratEx = intToDate(this.dataAsigurat);
		}
		return this._dataAsiguratEx;
	}
	public set dataAsiguratEx(value: Date) {
		if (this._dataAsiguratEx != value) {
			this._dataAsiguratEx = value;
			this.dataAsigurat = dateToInt(value);
		}
	}

	public deducereOug67: boolean;
	public oug16: boolean;
	public lunaPlataCenzor: number;
	public valoareSporWeekend: number;
	public copiiDeducereOug16100ron: number;
	public deducereOug16200ron: boolean;
	public pilonIiOptional: boolean = false;
	public tipNormaRegesId: number;
	public repartizareMuncaId: number;
	public detaliiRepartizareTimpMunca: string;
	public nivelStudiiId: number;
	public tipLocMuncaId: number;
	public tipTuraId: number;
	public judetLocMuncaId: number;
	public localitateLocMuncaId: number;
	public oraInceput: number;
	@Exclude()
	private _oraInceputEx: string;

	@Exclude()
	public get oraInceputEx(): string {
		if (!this._oraInceputEx && this.oraInceput != null) {
			const raw = this.oraInceput.toString().padStart(4, "0");
			const hours = raw.substring(0, 2);
			const minutes = raw.substring(2, 4);
			this._oraInceputEx = `${hours}:${minutes}`;
		}
		return this._oraInceputEx;
	}
	public set oraInceputEx(value: string) {
		if (this._oraInceputEx !== value) {
			this._oraInceputEx = value;

			if (value) {
				const [hours, minutes] = value.split(":").map((part) => parseInt(part, 10));
				this.oraInceput = hours * 100 + minutes;
			} else {
				this.oraInceput = null;
			}
		}
	}
	public oraSfarsit: number;
	@Exclude()
	private _oraSfarsitEx: string;

	@Exclude()
	public get oraSfarsitEx(): string {
		if (!this._oraSfarsitEx && this.oraSfarsit != null) {
			const raw = this.oraSfarsit.toString().padStart(4, "0");
			const hours = raw.substring(0, 2);
			const minutes = raw.substring(2, 4);
			this._oraSfarsitEx = `${hours}:${minutes}`;
		}
		return this._oraSfarsitEx;
	}
	public set oraSfarsitEx(value: string) {
		if (this._oraSfarsitEx !== value) {
			this._oraSfarsitEx = value;

			if (value) {
				const [hours, minutes] = value.split(":").map((part) => parseInt(part, 10));
				this.oraSfarsit = hours * 100 + minutes;
			} else {
				this.oraSfarsit = null;
			}
		}
	}
	public numarAutorizatie: string;
	public tipAutorizatieId: number;
	public tipAutorizatieExceptieId: number;
	public dataInceputAutorizatie: number;
	@Exclude()
	private _dataInceputAutorizatieEx: Date;
	@Exclude()
	public get dataInceputAutorizatieEx(): Date {
		if (!this._dataInceputAutorizatieEx && this.dataInceputAutorizatie) {
			this._dataInceputAutorizatieEx = intToDate(this.dataInceputAutorizatie);
		}
		return this._dataInceputAutorizatieEx;
	}
	public set dataInceputAutorizatieEx(value: Date) {
		if (this._dataInceputAutorizatieEx != value) {
			this._dataInceputAutorizatieEx = value;
			this.dataInceputAutorizatie = dateToInt(value);
		}
	}

	public dataSfarsitAutorizatie: number;
	@Exclude()
	private _dataSfarsitAutorizatieEx: Date;
	@Exclude()
	public get dataSfarsitAutorizatieEx(): Date {
		if (!this._dataSfarsitAutorizatieEx && this.dataSfarsitAutorizatie) {
			this._dataSfarsitAutorizatieEx = intToDate(this.dataSfarsitAutorizatie);
		}
		return this._dataSfarsitAutorizatieEx;
	}
	public set dataSfarsitAutorizatieEx(value: Date) {
		if (this._dataSfarsitAutorizatieEx != value) {
			this._dataSfarsitAutorizatieEx = value;
			this.dataSfarsitAutorizatie = dateToInt(value);
		}
	}
	public gradInvaliditateId: number;
	
	@Exclude({ toPlainOnly: true })
	public externalId: string;
	@Exclude({ toPlainOnly: true })
	public clientEid: string;
	@Exclude({ toPlainOnly: true })
	public validat: boolean;
	@Exclude({ toPlainOnly: true })
	public regesSalariatEid: string;
	@Exclude({ toPlainOnly: true })
	public regesContractEid: string;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public sex: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysCasaSanatate.typeProvider)
	public casaSanatate: SysCasaSanatate;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public tipDocumentPersonal: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysTipNorma.typeProvider)
	public tipNorma: SysTipNorma;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public repartizareTipMunca: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public durataContract: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public functieCor: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public conditiiMunca: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysStatusAngajat.typeProvider)
	public statusAngajat: SysStatusAngajat;

	@Exclude({ toPlainOnly: true })
	@Type(SysModelContract.typeProvider)
	public modelContract: SysModelContract;

	@Exclude({ toPlainOnly: true })
	@Type(SysTipAngajat.typeProvider)
	public tipAngajat: SysTipAngajat;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public tipOre: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public tipSporWeekend: SysDictionaryStandardFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryRegesFields.typeProvider)
	public tipNormaReges: SysDictionaryRegesFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryRegesFields.typeProvider)
	public repartizareMunca: SysDictionaryRegesFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryRegesFields.typeProvider)
	public nivelStudii: SysDictionaryRegesFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryRegesFields.typeProvider)
	public tipLocMunca: SysDictionaryRegesFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryRegesFields.typeProvider)
	public tipTura: SysDictionaryRegesFields;

	@Exclude({ toPlainOnly: true })
	@Type(CountyModel.typeProvider)
	public judetLocMunca: CountyModel;

	@Exclude({ toPlainOnly: true })
	@Type(CityModel.typeProvider)
	public localitateLocMunca: CityModel;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryRegesFields.typeProvider)
	public tipAutorizatie: SysDictionaryRegesFields;

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryRegesFields.typeProvider)
	public tipAutorizatieExceptie: SysDictionaryRegesFields;

	@Exclude({ toPlainOnly: true })
	@Type(CoasiguratModel.typeProvider)
	public coasigurati: CoasiguratModel[];

	@Exclude({ toPlainOnly: true })
	@Type(DeducereModel.typeProvider)
	public deduceri: DeducereModel[];

	@Exclude({ toPlainOnly: true })
	@Type(HandicapModel.typeProvider)
	public handicapuri: HandicapModel[];

	@Exclude({ toPlainOnly: true })
	@Type(SuspendareModel.typeProvider)
	public suspendari: SuspendareModel[];

	@Exclude({ toPlainOnly: true })
	@Type(SysDictionaryStandardFields.typeProvider)
	public gradInvaliditate: SysDictionaryStandardFields;
}

export class ChangeEmployeeSalaryModel {
	public employeeEid: string;
	public numar: string;
	public tarifarIncadrare: number;
	public dataModificare: number;
	@Exclude()
	private _dataModificareEx: Date;
	@Exclude()
	public get dataModificareEx(): Date {
		if (!this._dataModificareEx && this.dataModificare) {
			this._dataModificareEx = intToDate(this.dataModificare);
		}
		return this._dataModificareEx;
	}
	public set dataModificareEx(value: Date) {
		if (this._dataModificareEx != value) {
			this._dataModificareEx = value;
			this.dataModificare = dateToInt(value);
		}
	}
}

export class ChangeEmployeeMinimumSalaryModel {
	public employeeEid: string;
	public numar: string;
	public tarifarIncadrare: number;
	public dataModificare: number;
	@Exclude()
	private _dataModificareEx: Date;
	@Exclude()
	public get dataModificareEx(): Date {
		if (!this._dataModificareEx && this.dataModificare) {
			this._dataModificareEx = intToDate(this.dataModificare);
		}
		return this._dataModificareEx;
	}
	public set dataModificareEx(value: Date) {
		if (this._dataModificareEx != value) {
			this._dataModificareEx = value;
			this.dataModificare = dateToInt(value);
		}
	}

	@Exclude()
	public minimumWage: number;
	@Exclude()
	public hasMinimumWage: boolean;
	@Exclude()
	public minimumWageYearsExceeded: boolean;
}

export class EmployeeTerminationModel {
	public employeeEid: string;
	public numar: string;
	public nrZileCoNeefectuat: number;
	public dataPlecarii: number
	@Exclude()
	private _dataPlecariiEx: Date;
	@Exclude()
	public get dataPlecariiEx(): Date {
		if (!this._dataPlecariiEx && this.dataPlecarii) {
			this._dataPlecariiEx = intToDate(this.dataPlecarii);
		}
		return this._dataPlecariiEx;
	}
	public set dataPlecariiEx(value: Date) {
		if (this._dataPlecariiEx != value) {
			this._dataPlecariiEx = value;
			this.dataPlecarii = dateToInt(value);
		}
	}
}

export class EmployeeCdaTerminationModel {
	public employeeEid: string;
	public dataIncetarii: number
	@Exclude()
	private _dataIncetariiEx: Date;
	@Exclude()
	public get dataIncetariiEx(): Date {
		if (!this._dataIncetariiEx && this.dataIncetarii) {
			this._dataIncetariiEx = intToDate(this.dataIncetarii);
		}
		return this._dataIncetariiEx;
	}
	public set dataIncetariiEx(value: Date) {
		if (this._dataIncetariiEx != value) {
			this._dataIncetariiEx = value;
			this.dataIncetarii = dateToInt(value);
		}
	}
}

export class EmployeeMandatTerminationModel {
	public employeeEid: string;
	public dataIncetarii: number
	@Exclude()
	private _dataIncetariiEx: Date;
	@Exclude()
	public get dataIncetariiEx(): Date {
		if (!this._dataIncetariiEx && this.dataIncetarii) {
			this._dataIncetariiEx = intToDate(this.dataIncetarii);
		}
		return this._dataIncetariiEx;
	}
	public set dataIncetariiEx(value: Date) {
		if (this._dataIncetariiEx != value) {
			this._dataIncetariiEx = value;
			this.dataIncetarii = dateToInt(value);
		}
	}
}

export class EmployeeCertificateInputModel {
	public employeeEid: string;
	public purpose: string;
	public docNo: number;
	public today: number
	@Exclude()
	private _todayEx: Date;
	@Exclude()
	public get todayEx(): Date {
		if (!this._todayEx && this.today) {
			this._todayEx = intToDate(this.today);
		}
		return this._todayEx;
	}
	public set todayEx(value: Date) {
		if (this._todayEx != value) {
			this._todayEx = value;
			this.today = dateToInt(value);
		}
	}
	public ignoreWarnings: boolean = false;
	public months: number = 6;

	@Exclude()
	public documentType: string = "pdf";
	@Exclude()
	public certificateType: string;
	@Exclude()
	public certificateTitle: string;
	@Exclude()
	public hasPurpose: boolean = false;
	@Exclude()
	public hasMonths: boolean = false;
	@Exclude()
	public otherPurpose: string;
}